<template>
  <div
    v-if="$store.state.ordersLoaded && $store.state.organizationsLoaded && $store.state.productsLoaded"
  >
    <h3 class="headline">
      {{$store.getters.organizationName(order.organizationId)}}
      <small
        style="font-size: .75rem; display: block;"
      >{{ $route.params.orderId }}</small>
    </h3>
    <div v-for="(pickJobs, shelfId) in sortObject(order.pickJobs)" :key="shelfId">
      <h5 class="headline">
        <ShelfBadge :label="shelfId" />
      </h5>
      <ul class="list-group">
        <li
          v-for="(pickJob, i) in pickJobs"
          :key="i"
          class="list-group-item d-flex align-items-center product"
        >
          <div class="product-line">
            <div class="product-image-and-badge">
              <span
                :class="`badge badge-pill amount ${pickJob.amount > 1 ? 'badge-warning' : 'badge-primary'}`"
              >{{ pickJob.amount }}x</span>
              <div
                :style="
                `background-image: url(https://shop.mitemma.de/img/products/${
                  getProduct(pickJob.productId).img
                }_1200.jpg)`
              "
                class="product-image"
              ></div>
            </div>
            <span
              class="product-label"
            >{{ getProduct(pickJob.productId).brandName }} {{ getProduct(pickJob.productId).label }}</span>
          </div>
          <button class="btn btn-primary" @click="completePickJob(pickJob)">Picked</button>
        </li>
      </ul>
    </div>
    <div v-if="order.pickedItems && order.pickedItems.length > 0">
      <h3 class="headline">Abgeschlossene Pick Jobs</h3>
      <ul class="list-group">
        <li
          v-for="(pickedItem, i) in order.pickedItems"
          :key="i"
          class="list-group-item d-flex align-items-center product"
        >
          <div class="product-line">
            <div class="product-image-and-badge">
              <span class="badge badge-pill amount badge-primary">{{ pickedItem.amount }}x</span>
              <div
                :style="
                `background-image: url(https://shop.mitemma.de/img/products/${
                  getProduct(pickedItem.productId).img
                }_1200.jpg)`
              "
                class="product-image"
              ></div>
            </div>
            <span class="product-label">
              <strong style="display: block;">{{pickedItem.pickedFromSpace}}</strong>
              {{ getProduct(pickedItem.productId).brandName }} {{ getProduct(pickedItem.productId).label }}
            </span>
          </div>
          <button class="btn btn-danger" @click="undoPickJob({pickedItem, i})">Undo Pick</button>
        </li>
      </ul>
    </div>
    <div v-if="missingProducts(order.products).length > 0">
      <h5 class="headline">Fehlende Produkte</h5>
      <ul class="list-group">
        <li
          v-for="(product, productId) in missingProducts(order.products)"
          :key="productId"
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          <div>
            <small class="product-id">{{ productId }}</small>
            <br />
            {{ getProduct(productId).brandName }}
            {{ getProduct(productId).label }}
          </div>
          <span
            :class="
            `badge badge-pill amount ${product.needed - product.planned !== 0 ? 'badge-danger' : 'badge-primary'}`
          "
          >{{ product.planned }}/{{ product.needed }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ShelfBadge from '@/components/ShelfBadge'
import { fb, db } from '@/shared/firebase'

export default {
  components: { ShelfBadge },
  computed: {
    order: function() {
      const order = _.find(this.$store.state.orders, { id: this.$route.params.orderId })
      const { pickedItems, organizationId } = order
      const products = {}
      // count total products needed
      order.residents.forEach(resident => {
        resident.shoppingList.items.forEach(item => {
          const oldItemCount = products[item.productId] ? products[item.productId].needed : 0
          products[item.productId] = {
            needed: oldItemCount + item.amount,
            planned: 0
          }
        })
      })
      // get best pick options
      let pickJobs = []
      Object.keys(products).forEach(productId => {
        const product = products[productId]
        if (order.pickedItems) {
          const pickedItems = _.filter(order.pickedItems, { productId })
          pickedItems.forEach(pickedItem => {
            product.needed = product.needed - pickedItem.amount
          })
        }
        let pickOptions = this.$store.getters.stockByProductId(productId)
        if (pickOptions.length === 0) {
          product.available = false
        } else {
          // sort options by expiryDate, then by closest shelf
          pickOptions = _.orderBy(pickOptions, ['expiryDate', 'spaceId'], ['asc', 'asc'])

          // process pickJobs while less products are planned to pick then needed
          while (product.needed > product.planned) {
            // if there's still a pick option
            if (pickOptions[0]) {
              let { amount, spaceId } = pickOptions[0]

              if (amount > product.needed - product.planned) {
                amount = product.needed - product.planned
              }

              const pickJob = {
                productId,
                amount,
                spaceId
              }

              if (pickJob.amount > 0) {
                pickJobs.push(pickJob)
              }
              pickOptions.shift()
              product.planned = product.planned + amount
            } else {
              // if there's no pick option even though more is needed
              break
            }
          }
          product.available = product.planned === product.needed
        }
      })
      return { products, rawJobs: pickJobs, pickJobs: _.groupBy(pickJobs, 'spaceId'), pickedItems, organizationId }
    }
  },
  methods: {
    sortObject: function(o) {
      return Object.keys(o)
        .sort()
        .reduce((r, k) => ((r[k] = o[k]), r), {})
    },
    getProduct: function(productId) {
      const product = _.find(this.$store.state.products, { id: productId })
      return product
    },
    missingProducts: function(products) {
      Object.keys(products).forEach(productId => {
        if (products[productId].available !== false) {
          delete products[productId]
        }
      })
      return products
    },
    completePickJob: function(pickJob) {
      const { orderId } = this.$route.params
      const { productId, amount, spaceId } = pickJob
      const shelf = _.find(this.$store.state.shelves, { id: spaceId.substr(0, 2) }).spaces[spaceId.substr(2, 2)]
      const itemIndex = _.findIndex(shelf.items, { productId })
      shelf.items[itemIndex].amount = shelf.items[itemIndex].amount - amount
      db.doc(`orders/${orderId}`).update({
        pickedItems: fb.firestore.FieldValue.arrayUnion({
          productId,
          amount,
          pickedFromSpace: spaceId
        })
      })
      db.doc(`private/warehouse/shelves/${spaceId.substr(0, 2)}`).update({
        [`spaces.${spaceId.substr(2, 2)}.items`]: shelf.items
      })
    },
    undoPickJob: function(options) {
      const { pickedItem, i } = options
      const { orderId } = this.$route.params
      const { productId, amount, pickedFromSpace } = pickedItem
      const shelf = _.find(this.$store.state.shelves, { id: pickedFromSpace.substr(0, 2) }).spaces[
        pickedFromSpace.substr(2, 2)
      ]
      const itemIndex = _.findIndex(shelf.items, { productId })
      shelf.items[itemIndex].amount = shelf.items[itemIndex].amount + amount
      const pickedItems = this.order.pickedItems
      pickedItems.splice(i, 1)
      db.doc(`orders/${orderId}`).update({
        pickedItems
      })
      db.doc(`private/warehouse/shelves/${pickedFromSpace.substr(0, 2)}`).update({
        [`spaces.${pickedFromSpace.substr(2, 2)}.items`]: shelf.items
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-line {
  display: flex;
  flex-grow: 1;
  align-items: center;
}

.amount {
  position: absolute;
  top: 50%;
  margin-right: 0.5rem;

  font-size: 1.25rem;
}

.product-id {
  background: #eee;
  font-weight: bold;
  border-radius: 5px;
  padding: 0 0.25rem;
  margin-right: 0.5rem;
}

.product-image {
  flex-shrink: 0;
  display: inline-block;

  width: 8rem;
  height: 8rem;
  margin: 0 1rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

@media (max-width: 40rem) {
  .product-line {
    flex-direction: column;
  }

  .product-label {
    display: none;
  }
}
</style>
